export { default as useResizeAware } from 'react-resize-aware';